import { render, staticRenderFns } from "./FloatingUnitCard.vue?vue&type=template&id=f963dbee&scoped=true"
import script from "./FloatingUnitCard.vue?vue&type=script&lang=js"
export * from "./FloatingUnitCard.vue?vue&type=script&lang=js"
import style0 from "./FloatingUnitCard.vue?vue&type=style&index=0&id=f963dbee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f963dbee",
  null
  
)

export default component.exports